var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00019 16.0004C4.00019 15.7352 4.10555 15.4808 4.29308 15.2933C4.48062 15.1058 4.73497 15.0004 5.00019 15.0004L24.5864 15.0004L17.2927 7.70792C17.1998 7.61501 17.1261 7.50471 17.0758 7.38332C17.0255 7.26192 16.9996 7.13181 16.9996 7.00042C16.9996 6.86902 17.0255 6.73892 17.0758 6.61752C17.1261 6.49613 17.1998 6.38583 17.2927 6.29292C17.3856 6.20001 17.4959 6.12631 17.6173 6.07603C17.7387 6.02574 17.8688 5.99986 18.0002 5.99986C18.1316 5.99986 18.2617 6.02574 18.3831 6.07603C18.5045 6.12631 18.6148 6.20001 18.7077 6.29292L27.7077 15.2929C27.8007 15.3858 27.8744 15.4961 27.9247 15.6175C27.9751 15.7389 28.001 15.869 28.001 16.0004C28.001 16.1318 27.9751 16.262 27.9247 16.3834C27.8744 16.5048 27.8007 16.615 27.7077 16.7079L18.7077 25.7079C18.5201 25.8956 18.2656 26.001 18.0002 26.001C17.7348 26.001 17.4803 25.8956 17.2927 25.7079C17.105 25.5203 16.9996 25.2658 16.9996 25.0004C16.9996 24.7351 17.105 24.4806 17.2927 24.2929L24.5864 17.0004L5.00019 17.0004C4.73497 17.0004 4.48062 16.8951 4.29308 16.7075C4.10555 16.52 4.00019 16.2656 4.00019 16.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow1);
export default __webpack_public_path__ + "static/media/right-arrow-1.14a21c90885781948dab2dec294ec3ae.svg";
export { ForwardRef as ReactComponent };